import { render, staticRenderFns } from "./LibraryFormatTemplate.vue?vue&type=template&id=4d2e4ee4&scoped=true&"
import script from "./LibraryFormatTemplate.vue?vue&type=script&lang=js&"
export * from "./LibraryFormatTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LibraryFormatTemplate.vue?vue&type=style&index=0&id=4d2e4ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e4ee4",
  null
  
)

export default component.exports